// siteService.js
import { collection, getDocs } from 'firebase/firestore';
import { db } from './firebaseConfig';

export const fetchAllSites = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, 'IndividualSites'));
    const siteNames = querySnapshot.docs.map(doc => doc.data()); // Assuming 'name' is the field for site names
    // console.log('All Site Names:', siteNames);
    return siteNames;
  } catch (error) {
    console.error('Error fetching site names:', error);
    return [];
  }
};
